const PropTypes = require('prop-types');
const React = require('react');
const { cmsPagePath } = require('../../components/shared/url_helpers');
const classNames = require('classnames');

class ShippingProtectionInput extends React.Component {
  onChange() {
    if (this.props.showDisabled) return null;
    this.props.toggleShipmentInsurance();
    return true;
  }

  disabledValue() {
    if (this.props.showDisabled) {
      return 'disabled';
    }
    return '';
  }

  checkedValue() {
    if (this.showChecked()) {
      return 'checked';
    }
    return '';
  }

  hiddenInputValue() {
    if (this.showChecked()) {
      return '1';
    }
    return '0';
  }

  showChecked() {
    if (this.props.cannotInsure) return false;

    return (this.props.insuranceRequired || this.props.shipmentInsured);
  }

  learnMoreLink() {
    return cmsPagePath('shipping-guide#reverb-shipping-protection');
  }

  warningText() {
    if (this.props.cannotInsure) {
      return I18n.t('js.dashboard.selling.shippingLabels.insurance.cannotInsureHighValuePackageHtml', { linkOpen: `<a href=${this.learnMoreLink()}>`, linkClose: '</a>' });
    }
    return I18n.t('js.dashboard.selling.shippingLabels.insurance.requiredInsuranceHtml', { linkOpen: `<a href=${this.learnMoreLink()}>`, linkClose: '</a>' });
  }

  renderInsuranceInfo() {
    if (this.props.showDisabled) {
      return (
        <div
          className="shipping-label__checkbox-hint"
          dangerouslySetInnerHTML={{ __html: this.warningText() }}
        />
      );
    }
    return (
      <div className="shipping-label__checkbox-hint">
        {I18n.t('js.dashboard.selling.shippingLabels.insurance.insuranceInfo', { insuranceCost: this.props.formattedInsuranceCost })}
      </div>
    );
  }

  render() {
    return (
      <div className="mb-1">
        <div className="label-with-checkbox">
          <input
            name="shipping_label_form[insured]"
            disabled={this.disabledValue()}
            type="hidden"
            value={this.hiddenInputValue()}
          />
          <input
            onChange={() => this.onChange()}
            disabled={this.disabledValue()}
            checked={this.checkedValue()}
            type="checkbox"
            value="1"
            name="shipping_label_form[insured]"
            id="shipping_label_form[insured]"
          />
          <label htmlFor="shipping_label_form[insured]" className={classNames(['shipping-label__checkbox-label', { 'opacity-50': this.props.cannotInsure }])}>
            {I18n.t('js.dashboard.selling.shippingLabels.insurance.shippingProtectionTitle')}
          </label>
        </div>
        {this.renderInsuranceInfo()}
      </div>
    );
  }
}

ShippingProtectionInput.propTypes = {
  cannotInsure: PropTypes.bool.isRequired,
  showDisabled: PropTypes.bool.isRequired,
  insuranceRequired: PropTypes.bool.isRequired,
  shipmentInsured: PropTypes.bool.isRequired,
  toggleShipmentInsurance: PropTypes.func.isRequired,
  formattedInsuranceCost: PropTypes.string,
};

ShippingProtectionInput.defaultProps = {
  cannotInsure: false,
  showDisabled: false,
  insuranceRequired: false,
  shipmentInsured: true,
  toggleShipmentInsurance: () => true,
};

module.exports = ShippingProtectionInput;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/shipping_protection_input.jsx